import $ from 'jquery';

function openAccordion(accordion) {
  let discloseSymbol = accordion.find('.accordion__disclose-symbol')[0];
  let body = accordion.find('.accordion__body');
  let collapsed = accordion.hasClass('accordion-collapsed');
  if (collapsed) {
    accordion.removeClass('accordion-collapsed');
    if (discloseSymbol) {
      discloseSymbol.setDirection('bottom');
    }
  }
}

function closeAccordion(accordion) {
  let discloseSymbol = accordion.find('.accordion__disclose-symbol')[0];
  let body = accordion.find('.accordion__body');
  let collapsed = accordion.hasClass('accordion-collapsed');
  if (!collapsed) {
    accordion.addClass('accordion-collapsed');
    if (discloseSymbol) {
      discloseSymbol.setDirection('right');
    }
  }
}

function toggleAccordion(accordion) {
  let discloseSymbol = accordion.find('.accordion__disclose-symbol')[0];
  let body = accordion.find('.accordion__body');
  let collapsed = accordion.hasClass('accordion-collapsed');
  if (collapsed) {
    accordion.removeClass('accordion-collapsed');
    if (discloseSymbol) {
      discloseSymbol.setDirection('bottom');
    }
  } else {
    accordion.addClass('accordion-collapsed');
    if (discloseSymbol) {
      discloseSymbol.setDirection('right');
    }
  }
}

$(() => {
  $('.accordion-button-collapse').hide();

  $('.accordion__header').click((event) => {
    let accordion = $(event.target).closest('.accordion');
    toggleAccordion(accordion);
  });

  $('.accordion-button-expand button').click(() => {
    $('.accordion').each(function(index) {
      const accordion = $(this);
      openAccordion(accordion);
    });
    $('.accordion-button-expand').hide();
    $('.accordion-button-collapse').show();
  });

  $('.accordion-button-collapse button').click(() => {
    $('.accordion').each(function(index) {
      const accordion = $(this);
      closeAccordion(accordion);
    });
    $('.accordion-button-collapse').hide();
    $('.accordion-button-expand').show();
    
  });
});
